function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.4841 9.70638C2.08825 10.1343 1.41175 10.1343 1.0159 9.70638L0.628113 9.28715C0.273579 8.90387 0.27358 8.31235 0.628114 7.92907L6.7659 1.29362C7.16175 0.865677 7.83825 0.865677 8.2341 1.29362L14.3719 7.92907C14.7264 8.31235 14.7264 8.90387 14.3719 9.28715L13.9841 9.70638C13.5883 10.1343 12.9117 10.1343 12.5159 9.70638L8.2341 5.0774C7.83825 4.64946 7.16175 4.64946 6.7659 5.0774L2.4841 9.70638Z",
  fill: "#8A93A6"
});

var SvgSelectUp = function SvgSelectUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelectUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/select-up.d00131f1.svg";
export { ForwardRef as ReactComponent };